module.exports = __webpack_public_path__ + "static/img/SG.b09f8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/SG.png
// module id = v9Fk
// module chunks = 0